module.exports = __webpack_public_path__ + "static/img/p5.3759de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p5.png
// module id = FUOp
// module chunks = 0